var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('d-button',{staticClass:"scroll-to-top rounded-circle",style:({
    bottom: '70px',
  }),attrs:{"id":"tooltip-scroll-top"},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fas fa-arrow-up"}),_c('d-tooltip',{attrs:{"target":"tooltip-scroll-top","placement":"top","delay":{ show: 500, hide: 1000 }}},[_vm._v("\n    "+_vm._s(_vm.$t('shared.scrollToTop.tooltip'))+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }